import { Amplify } from "aws-amplify";

// Amplify.Logger.LOG_LEVEL = 'DEBUG' // Use this for Debugging amplify issues

let isConfigured = false;

export const configureAmplify = () => {
  if (!isConfigured) {
    Amplify.configure({
      Auth: {
        Cognito: {
          identityPoolId: import.meta.env
            .VITE_COGNITO_IDENTITY_POOL_ID as string,
          allowGuestAccess: true
        }
      }
    });
    isConfigured = true;
  }
};
